import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.png";
import "./Sidebar.css";
import { Icon } from "react-icons-kit";
import { arrow_down } from "react-icons-kit/ikons/arrow_down";
import { tv } from "react-icons-kit/feather/tv";
import { useNavigate, useLocation } from "react-router-dom";
import { useJwt } from "react-jwt";
import { DeleteEmployee, GetEmployePage } from "../apiconfig/authService";
import { Pagination } from "rsuite";
import { FaUser } from "react-icons/fa";
import { AiFillProduct } from "react-icons/ai";
import { CiShoppingCart } from "react-icons/ci";
import { MdCategory } from "react-icons/md";
import { TbCategoryPlus } from "react-icons/tb";
import { TfiLayoutMediaOverlayAlt } from "react-icons/tfi";
import { TfiLayoutSlider } from "react-icons/tfi";
import { MdFeedback } from "react-icons/md";
import { FaStore } from "react-icons/fa6";
import { FaUserTie } from "react-icons/fa6";
import { FaCircleUser } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";
import { TbBrandDatabricks } from "react-icons/tb";
import { FaShop } from "react-icons/fa6";
import { MdShoppingCart } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { GrGallery } from "react-icons/gr";
import { FaCircleInfo } from "react-icons/fa6";
import { TbListDetails } from "react-icons/tb";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaChevronDown } from "react-icons/fa";
import { IoMenu } from "react-icons/io5";

const Sidebar = () => {
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [employeesData, setEmployeesData] = useState([]);
  const [searchedEmployeesData, setSearchedEmployeesData] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [recordIdToDelete, setRecordIdToDelete] = useState("");

  // Consolidated dropdown state
  const [openDropdown, setOpenDropdown] = useState(null);

  const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
      navigate('/');

  // Function to handle dropdown toggle - only one can be open at a time
  const handleDropdownToggle = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  // Auto-open dropdowns based on current route
  useEffect(() => {
    if (
      location.pathname.includes("/employee") ||
      location.pathname.includes("/addEmployee") ||
      location.pathname.includes("/viewEmployee") ||
      location.pathname.includes("/editEmployee") ||
      location.pathname.includes("/customer") ||
      location.pathname.includes("/viewCustomer")
    ) {
      setOpenDropdown("user");
    } else if (
      location.pathname.includes("/category") ||
      location.pathname.includes("/addCategory") ||
      location.pathname.includes("/editCategory") ||
      location.pathname.includes("/viewCategory") ||
      location.pathname.includes("/subcategory") ||
      location.pathname.includes("/addSubcategory") ||
      location.pathname.includes("/viewSubcategory") ||
      location.pathname.includes("/editSubcategory")
    ) {
      setOpenDropdown("category");
    } else if (
      location.pathname.includes("/media") ||
      location.pathname.includes("/addMedia") ||
      location.pathname.includes("/viewMedia") ||
      location.pathname.includes("/editMedia") ||
      location.pathname.includes("/slider") ||
      location.pathname.includes("/addSlider") ||
      location.pathname.includes("/viewSlider") ||
      location.pathname.includes("/editSlider")
    ) {
      setOpenDropdown("media");
    } else if (
      location.pathname.includes("/feedback") ||
      location.pathname.includes("/viewFeedback") ||
      location.pathname.includes("/stores") ||
      location.pathname.includes("/addStore") ||
      location.pathname.includes("/viewStore") ||
      location.pathname.includes("/editStore")
    ) {
      setOpenDropdown("feedback");
    } else if (
      location.pathname.includes("/wedget") ||
      location.pathname.includes("/addwidget") ||
      location.pathname.includes("/viewWedget") ||
      location.pathname.includes("/editwedget") ||
      location.pathname.includes("/banner") ||
      location.pathname.includes("/addbanner") ||
      location.pathname.includes("/viewBanner") ||
      location.pathname.includes("/editBanner") ||
      location.pathname.includes("/brand") ||
      location.pathname.includes("/addbrand") ||
      location.pathname.includes("/viewbrand") ||
      location.pathname.includes("/editbrand") ||
      location.pathname.includes("/tags") ||
      location.pathname.includes("/addtag") ||
      location.pathname.includes("/viewtag") ||
      location.pathname.includes("/editTag") ||
      location.pathname.includes("/notification") ||
      location.pathname.includes("/addnotification") ||
      location.pathname.includes("/viewnotification") ||
      location.pathname.includes("/EditNotification")
    ) {
      setOpenDropdown("layout");
    } else if (
      location.pathname.includes("/order") ||
      location.pathname.includes("/product") ||
      location.pathname.includes("/addProduct") ||
      location.pathname.includes("/editProduct") ||
      location.pathname.includes("/viewProduct")
    ) {
      setOpenDropdown("orderProduct");
    } else if (
      location.pathname.includes("/blinkit") ||
      location.pathname.includes("/zepto") ||
      location.pathname.includes("/dmart") ||
      location.pathname.includes("/swiggy") ||
      location.pathname.includes("/bigBasket") ||
      location.pathname.includes("/jiomart") ||
      location.pathname.includes("/flipkart") ||
      location.pathname.includes("/amazon") ||
      location.pathname.includes("/flipkartmintues")
    ) {
      setOpenDropdown("store");
    }
  }, [location.pathname]);

  const handleSignoutClick = async () => {
    localStorage.removeItem("accessToken");
    navigate("/");
  };

  useEffect(() => {
    setSearchedEmployeesData(
      employeesData.filter(
        (item) =>
          item.firstname?.includes(search) ||
          item.lastname?.includes(search) ||
          item.emailid?.includes(search)
      )
    );
  }, [search, employeesData]);

  useEffect(() => {
    (async () => {
      try {
        const response = await GetEmployePage(
          page,
          itemsPerPage,
          localStorage.getItem("accessToken")
        );
        setEmployeesData([...response.data.items]);
        setSearchedEmployeesData([...response.data.items]);
        setTotalEmployees(response.data.pagination.count);
        setPageCount(Math.ceil(response.data.pagination.pageCount));
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, itemsPerPage]);

  const handleViewCategoryClick = (emailid) => {
    navigate(`/myprofile/${emailid}`);
  };

  const firstEmail =
    searchedEmployeesData.length > 0 ? searchedEmployeesData[0].emailid : null;

  const [activeItem, setActiveItem] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Helper function to get rotation style for icons
  const getIconRotation = (dropdownName) => ({
    transform:
      openDropdown === dropdownName ? "rotate(180deg)" : "rotate(0deg)",
    transition: "transform 0.3s ease-in-out",
  });

  return (
    <div>
      <div className="nav-only-phone d-md-none">
        <div className="img-pi-logo">
          <img src="/static/media/logo.1c08c1e01e0bf9677c66.png" alt="" />
        </div>
        <button className="btn btn-primary d-md-none" onClick={toggleSidebar}>
          <IoMenu size={30} />
        </button>
      </div>

      <div
        className="modal fade"
        id="signoutModal"
        tabIndex="10"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body text-center p-5">
              <h1 className="modal-title display-6 mb-4" id="exampleModalLabel">
                Procced with Signout?
              </h1>
              <button
                type="button"
                className="btn btn-danger me-2"
                data-bs-dismiss="modal"
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSignoutClick();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`sidebar offcanvas offcanvas-start ${
          isSidebarOpen ? "show" : ""
        }`}
        data-bs-scroll="true"
        data-bs-backdrop="false"
        tabIndex="-1"
        id="offcanvasScrolling"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div className="profile offcanvas-header p-2 flex-wrap bg-light">
          <button
            className="btn btn-toggle collapsed userProfile d-flex align-items-center w-100 position-relative"
            data-bs-toggle="collapse"
            data-bs-target="#profile-collapse"
            aria-expanded="false"
          >
            <span className="userPic">
              <img className="img-fluid" src={logoImg} width="50" alt="" />
            </span>
            <span className="nameTag">
              <span className="offcanvas-title h5" id="offcanvasScrolling">
                Pikeazy
              </span>
              <span className="clearfix"></span>
              <Icon
                className="arrow_down"
                icon={arrow_down}
                size={20}
                style={{ marginTop: "10px" }}
              />
            </span>
          </button>
          <div className="collapse dropdownList" id="profile-collapse">
            <ul className="btn-toggle-nav list-unstyled">
              <li className="active">
                <button
                  type="button"
                  className="profilebutton"
                  onClick={() => {
                    handleViewCategoryClick(firstEmail);
                  }}
                >
                  <FaCircleUser size={17} className="profile-icon" />
                  My Profile
                </button>
              </li>
              <li>
                <button
                  style={{
                    marginTop: "10px",
                    listStyle: "inside",
                  }}
                  type="button"
                  className="profilebutton"
                  onClick={() => handleSignoutClick()}
                >
                  <FiLogOut size={17} className="profile-icon" />
                  Log Out
                </button>
              </li>
            </ul>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <ul className="offcanvas-body list-unstyled p-0 mb-0">
          <li className="dropdownList">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive ? "actives nav-link" : "nav-link"
              }
            >
              <MdDashboard size={17} className="icon" />
              Dashboard
            </NavLink>
          </li>

          {/* User Management Start */}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${
                openDropdown === "user" ? "active" : ""
              }`}
              onClick={() => handleDropdownToggle("user")}
            >
              <span className="d-flex align-items-center">
                <FaUserTie size={17} className="icon" />
                <span className="text-custom-13">User Management</span>
              </span>
              <FaChevronDown size={10} style={getIconRotation("user")} />
            </button>

            <div className={`dropdown-container ${openDropdown === "user" ? "open" : ""}`}>
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/employee"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <FaUserTie size={17} className="icon" />
                    <span className="inside-list-tab">Employee</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/customer"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <FaUser size={17} className="icon" />
                    <span className="inside-list-tab">Customer</span>
                  </NavLink>
                </li>
              </ul>
            </div>

          </li>

          {/* Product Management Start*/}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${
                openDropdown === "orderProduct" ? "active" : ""
              }`}
              onClick={() => handleDropdownToggle("orderProduct")}
            >
              <span className="d-flex align-items-center">
                <MdShoppingCart size={17} className="icon" />
                <span className="text-custom-13">Product Management</span>
              </span>
              <FaChevronDown size={10} style={getIconRotation("orderProduct")} />
            </button>

              <div className={`dropdown-container ${openDropdown === "orderProduct" ? "open" : ""}`}>
                <ul className="list-unstyled ps-4">
                  <li className="dropdownList">
                    <NavLink
                      to="/product"
                      className={({ isActive }) =>
                        isActive ? "actives nav-link" : "nav-link"
                      }
                    >
                      <AiFillProduct size={17} className="icon" />
                      <span className="inside-list-tab">Product</span>
                    </NavLink>
                  </li>
                </ul>
              </div>
          </li>

          {/* Category Management start*/}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${
                openDropdown === "category" ? "active" : ""
              }`}
              onClick={() => handleDropdownToggle("category")}
            >
              <span className="d-flex align-items-center">
                <MdCategory size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span">
                  Category Management
                </span>
              </span>
              <FaChevronDown size={10} style={getIconRotation("category")} />
            </button>

              <div className={`dropdown-container ${openDropdown === "category" ? "open" : ""}`}>
                <ul className="list-unstyled ps-4">
                  <li className="dropdownList">
                    <NavLink
                      to="/category"
                      className={({ isActive }) =>
                        isActive ? "actives nav-link" : "nav-link"
                      }
                    >
                      <MdCategory size={17} className="icon" />
                      <span className="inside-list-tab">Category</span>
                    </NavLink>
                  </li>
                  <li className="dropdownList">
                    <NavLink
                      to="/subcategory"
                      className={({ isActive }) =>
                        isActive ? "actives nav-link" : "nav-link"
                      }
                    >
                      <TbCategoryPlus size={17} className="icon" />
                      <span className="inside-list-tab">Subcategory</span>
                    </NavLink>
                  </li>
                </ul>
              </div>
          </li>

          {/* Media Management Start*/}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${
                openDropdown === "media" ? "active" : ""
              }`}
              onClick={() => handleDropdownToggle("media")}
            >
              <span className="d-flex align-items-center">
                <TfiLayoutMediaOverlayAlt size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">
                  Media Management
                </span>
              </span>
              <FaChevronDown size={10} style={getIconRotation("media")} />
            </button>

            <div className={`dropdown-container ${openDropdown === "media" ? "open" : ""}`}>
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/media"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <TfiLayoutMediaOverlayAlt size={17} className="icon" />
                    <span className="inside-list-tab">Media</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/slider"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <TfiLayoutSlider size={17} className="icon" />
                    <span className="inside-list-tab">Slider</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* Feedback management Start */}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${
                openDropdown === "feedback" ? "active" : ""
              }`}
              onClick={() => handleDropdownToggle("feedback")}
            >
              <span className="d-flex align-items-center">
                <MdFeedback size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">
                  Feedback Management
                </span>
              </span>
              <FaChevronDown size={10} style={getIconRotation("feedback")} />
            </button>

            <div className={`dropdown-container ${openDropdown === "feedback" ? "open" : ""}`}>
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/feedback"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <MdFeedback size={17} className="icon" />
                    <span className="inside-list-tab">Feedback</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/stores"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <FaShop size={17} className="icon" />
                    <span className="inside-list-tab">Stores</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* Layout management Start */}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${
                openDropdown === "layout" ? "active" : ""
              }`}
              onClick={() => handleDropdownToggle("layout")}
            >
              <span className="d-flex align-items-center">
                <FaStore size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">
                  Layout Management
                </span>
              </span>
              <FaChevronDown size={10} style={getIconRotation("layout")} />
            </button>

            <div className={`dropdown-container ${openDropdown === "layout" ? "open" : ""}`}>
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/wedget"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <FaStore size={17} className="icon" />
                    <span className="inside-list-tab">Widget</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/banner"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <GrGallery size={17} className="icon" />
                    <span className="inside-list-tab">Banner</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/brand"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <TbBrandDatabricks size={17} className="icon" />
                    <span className="inside-list-tab">Brand</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/tags"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <TbBrandDatabricks size={17} className="icon" />
                    <span className="inside-list-tab">Tags</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/notification"
                    className={({ isActive }) =>
                      isActive ? "actives nav-link" : "nav-link"
                    }
                  >
                    <TbBrandDatabricks size={17} className="icon" />
                    <span className="inside-list-tab">Notification</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* Store Management start*/}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${
                openDropdown === "store" ? "active" : ""
              }`}
              onClick={() => handleDropdownToggle("store")}
            >
              <span className="d-flex align-items-center">
                <TbListDetails size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">
                  Store Management
                </span>
              </span>
              <FaChevronDown size={10} style={getIconRotation("store")} />
            </button>

            <div className={`dropdown-container ${openDropdown === "store" ? "open" : ""}`}>
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/blinkit"
                    className={`nav-link my-2 ${activeItem === "blinkit" ? "active" : ""}`}
                    onClick={() => setActiveItem("blinkit")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">Blinkit</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/zepto"
                    className={`nav-link my-2 ${activeItem === "zepto" ? "active" : ""}`}
                    onClick={() => setActiveItem("zepto")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">Zepto</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/dmart"
                    className={`nav-link my-2 ${activeItem === "dmart" ? "active" : ""}`}
                    onClick={() => setActiveItem("dmart")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">Dmart</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/swiggy"
                    className={`nav-link my-2 ${activeItem === "swiggy" ? "active" : ""}`}
                    onClick={() => setActiveItem("swiggy")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">Swiggy</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/bigBasket"
                    className={`nav-link my-2 ${activeItem === "bigbasket" ? "active" : ""}`}
                    onClick={() => setActiveItem("bigbasket")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">BigBasket</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/jiomart"
                    className={`nav-link my-2 ${activeItem === "jiomart" ? "active" : ""}`}
                    onClick={() => setActiveItem("jiomart")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">Jiomart</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/flipkart"
                    className={`nav-link my-2 ${activeItem === "flipkart" ? "active" : ""}`}
                    onClick={() => setActiveItem("flipkart")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">Flipkart</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/amazon"
                    className={`nav-link my-2 ${activeItem === "amazon" ? "active" : ""}`}
                    onClick={() => setActiveItem("amazon")}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    <span className="inside-list-tab">Amazon</span>
                  </NavLink>
                </li>
              </ul>
            </div>

          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;